// extracted by mini-css-extract-plugin
export var infoSection = "_l-1";
export var infoSectionContainer = "_l-0";
export var infoSectionTitleRow = "_l-2";
export var multiLineInfo = "_l-4";
export var strong = "_l-3";